import {graphqlQuery} from '../utils/graphqlQuery';

export const OPERATION_NAME = 'graphql_get_discoveryFeedsByListingId';

export const recommendedPropertiesQuery = `
    query recommendedListing($listingTriads: [String!]!, $currency: String!, $startDate: String, $endDate: String, $size: Int, $target: PropertyTarget) {
        recommendedListingResponse(listingTriads: $listingTriads, startDate: $startDate, endDate: $endDate, size: $size, target: $target) {
            message {
                carouselTitle
            }
            clientRequestId
            recommendedListings {
                listing {
                    address {
                        city
                        country
                        stateProvince
                    }
                    averagePrice {
                        localized
                    }
                    averagePriceSummary: priceSummary(currency: $currency) {
                        pricePeriodDescription
                        formattedAmount
                    }
                    averageRating
                    bathrooms {
                        full
                    }
                    bedrooms
                    detailPageUrl
                    headlinePhoto(treatment: C4) {
                        uri
                    }
                    instantBookable
                    listingId
                    totalPrice {
                        localized
                    }
                    totalPriceSummary: priceSummary(currency: $currency, summary: "total") {
                        pricePeriodDescription
                        formattedAmount
                    }
                    propertyMetadata {
                        headline
                    }
                    reviewCount
                    sleeps
                    spu
                }
            }
        }
    }`;

export async function getRecommendedPropertiesGraphQl({
    listingTriads,
    startDate,
    endDate,
    size,
    target,
    currency,
    fallback
}) {
    let params = {
        listingTriads,
        size,
        target,
        currency
    };
    if (startDate) params = {...params, startDate};
    if (endDate) params = {...params, endDate};
    if (fallback) params = {...params, fallback};
    return graphqlQuery(OPERATION_NAME, recommendedPropertiesQuery, params);
}

export default getRecommendedPropertiesGraphQl;
